import { requests } from './baseServices'

export const TemplateServices = {    
    getAll: (criteria) => requests.get('api/templates', criteria),
    getAllWithOptions: (criteria) => requests.post('api/templates/filtered', criteria),
    getById: (id) => requests.get(`api/templates/${id}`),
    update: (id, template) => requests.put(`api/templates/${id}`, template),
    create: (template) => requests.post(`api/templates`, template),
    duplicate: (id) => requests.post(`api/templates/duplicate/${id}`),
    delete: (id) => requests.delete(`api/templates/${id}`),
    send: (dto) => requests.post(`api/templates/send`,dto),
};